/* Ad click IDs → cart attributes → order, so the hub can tell paid visits from organic ones.
   Shopify keeps the landing page without its query string, so a Google Ads click looks like an organic
   Google visit unless the click ID travels with the order.

   - Reads gclid, gbraid, wbraid, fbclid, ttclid, msclkid and utm_source / utm_medium / utm_campaign from the URL.
   - Advertising identifiers: nothing is stored or sent unless the visitor has allowed marketing
     (Shopify Customer Privacy API). A click that lands before consent is held in memory only and kept
     if consent is given on that page.
   - Last click wins, kept 90 days, in localStorage with a first-party cookie fallback.
   - Written to the cart as hidden attributes (_gclid, ..., _click_at). Pushed when captured, on each page
     load once the cart has items, after an add to cart, and before checkout. Empty values are never sent,
     so an existing attribute is never blanked. */
(function () {
  var PARAMS = ['gclid', 'gbraid', 'wbraid', 'fbclid', 'ttclid', 'msclkid', 'utm_source', 'utm_medium', 'utm_campaign'];
  var CLICK_IDS = ['gclid', 'gbraid', 'wbraid', 'fbclid', 'ttclid', 'msclkid'];
  var KEY = 'fc_click', DAYS = 90;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var pending = null;   // captured from this URL, waiting for consent

  /* ── capture from the URL ── */
  try {
    var q = new URLSearchParams(location.search), got = {}, any = false, hasClick = false;
    PARAMS.forEach(function (p) { var v = q.get(p); if (v) { got[p] = v.slice(0, 255); any = true; if (CLICK_IDS.indexOf(p) >= 0) hasClick = true; } });
    if (any) { got.click_at = new Date().toISOString(); got.hasClick = hasClick; pending = got; }
  } catch (e) {}

  /* ── consent ── */
  function marketingAllowed() {
    try { return !!(window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.marketingAllowed()); } catch (e) { return false; }
  }

  /* ── storage ── */
  function read() {
    var raw = null;
    try { raw = localStorage.getItem(KEY); } catch (e) {}
    if (!raw) { var m = document.cookie.match(/(?:^|;\s*)fc_click=([^;]+)/); if (m) { try { raw = decodeURIComponent(m[1]); } catch (e) {} } }
    if (!raw) return null;
    try { var d = JSON.parse(raw); if (!d || !d.click_at || Date.now() - Date.parse(d.click_at) > DAYS * 864e5) return null; return d; } catch (e) { return null; }
  }
  function write(d) {
    var raw = JSON.stringify(d);
    try { localStorage.setItem(KEY, raw); } catch (e) {}
    try { document.cookie = 'fc_click=' + encodeURIComponent(raw) + ';path=/;max-age=' + DAYS * 86400 + ';SameSite=Lax' + (location.protocol === 'https:' ? ';Secure' : ''); } catch (e) {}
  }
  function forget() {
    try { localStorage.removeItem(KEY); } catch (e) {}
    try { document.cookie = 'fc_click=;path=/;max-age=0'; } catch (e) {}
  }

  /* Store a pending click. A UTM-only visit (no click ID) never replaces a stored ad click,
     so an email link after an ad click does not wipe the gclid; any new click ID replaces it all. */
  function commit() {
    if (!pending) return;
    var cur = read();
    if (pending.hasClick || !cur || !hasClickId(cur)) { var d = {}; for (var k in pending) if (k !== 'hasClick') d[k] = pending[k]; write(d); }
    pending = null;
  }
  function hasClickId(d) { return CLICK_IDS.some(function (k) { return !!d[k]; }); }

  /* ── cart ── */
  function attrs(d) {
    var a = {};
    PARAMS.forEach(function (p) { if (d[p]) a['_' + p] = d[p]; });
    a._click_at = d.click_at;
    return a;
  }
  var inflight = null;
  // Push to the cart if it has items and does not already carry this click. Resolves either way.
  function push(force) {
    if (!marketingAllowed()) return Promise.resolve();
    var d = read();
    if (!d) return Promise.resolve();
    if (inflight) return inflight;
    inflight = fetch(ROOT + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var have = (cart && cart.attributes) || {};
      if (!force && (!cart || !cart.item_count)) return;
      if (have._click_at === d.click_at) return;
      return fetch(ROOT + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attrs(d) })
      });
    }).catch(function () {}).then(function () { inflight = null; });
    return inflight;
  }

  /* After an add to cart (fetch or XHR to /cart/add), the cart now exists: attach the click. */
  function isAdd(url) { return /\/cart\/add(\.js)?(\?|$)/.test(String(url || '')); }
  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url);
      var p = _fetch.apply(this, arguments);
      if (isAdd(url)) p.then(function (r) { if (r && r.ok) setTimeout(push, 0); }).catch(function () {});
      return p;
    };
  }
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (isAdd(url)) this.addEventListener('load', function () { if (this.status < 400) setTimeout(push, 0); });
    return _open.apply(this, arguments);
  };

  /* Before checkout: hold the navigation until the attributes are on the cart (max 1.5s). */
  function isCheckout(el) {
    if (!el) return false;
    if ((el.name === 'checkout') && /button|input/i.test(el.tagName)) return true;
    var href = el.getAttribute && el.getAttribute('href');
    return !!href && /(^|\/)checkout(\?|$|\/)/.test(href);
  }
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest && e.target.closest('a[href], button[name="checkout"], input[name="checkout"]');
    if (!isCheckout(el) || el.__fcClickDone || !marketingAllowed() || !read()) return;
    e.preventDefault();
    var go = function () {
      el.__fcClickDone = true;
      if (el.tagName === 'A') location.href = el.href; else el.click();
    };
    Promise.race([push(true), new Promise(function (r) { setTimeout(r, 1500); })]).then(go, go);
  }, true);

  /* ── start ── */
  function start() {
    if (marketingAllowed()) { commit(); push(); }
  }
  document.addEventListener('visitorConsentCollected', function (e) {
    var ok = e && e.detail && e.detail.marketingAllowed;
    if (ok) { commit(); push(); } else { pending = null; forget(); }
  });
  function load() {
    if (window.Shopify && Shopify.customerPrivacy) return start();
    if (window.Shopify && Shopify.loadFeatures) {
      Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (!err) start(); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', load); else load();
})();
